import Image      from "_components/atoms/image";
import Loader     from "_components/atoms/loader";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/atoms/emptyChatMessageView";

const Component = ( { isLoading, msg } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.emptyChatViewContainer }>
			<div>
				<Image
					className = { classes.icon }
					src       = "/images/empty-chat.webp"
				/>

				<Typography
					className = { classes.messageText }
					color     = "secondary"
					title     = { msg }
				/>

				{isLoading ? (
					<div className = { classes.loaderContainer }>

						<Loader />

					</div>
				) : null}

			</div>
		</div>
	);
};

export default Component;
